import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FilterBase } from '@myapp/features/admin/models';
import { AdminService } from '@myapp/features/admin/services';
import { displayModalEditorComponent, ModalOptions } from '@myapp/features/widgets/models';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { GridDataResult, PageChangeEvent, RowClassArgs } from '@progress/kendo-angular-grid';
import { process } from "@progress/kendo-data-query";

@Component({
  selector: 'app-base-grid',
  templateUrl: './base-grid.component.html'
})
export abstract class BaseGridComponent<T> implements OnInit {
  public gridData: GridDataResult = { data: [], total: 0 };

  public items: T[] = [];
  public filteredItems: T[] = [];
  public filter?: FilterBase;

  public pageSize = 10;
  public skip = 0;

  public sizes = [10, 20, 50];

  constructor(public adminService: AdminService
    , private modalService: NgbModal)
  {
    this.allData = this.allData.bind(this);
  }

  public ngOnInit(): void {
    this.retrieveItems();
  }

  abstract retrieveItems(): void;


  public onFilter(target: EventTarget | null): void {
    if (target != null && target instanceof HTMLInputElement) {
      const inputValue: string = target.value;
      if (this.filter) {
        this.filteredItems = process(this.items, this.filter.GetFilter(inputValue)).data;
        this.skip = 0;
        this.loadItems();
      }
    }
  }

  abstract refreshItems(): void;

  abstract addHandler({ sender }: any): void;

  abstract editHandler({ sender, rowIndex, dataItem }: any): void;

  public showEditorModal(size: string, options: ModalOptions, component: any, formGroup: FormGroup, isNew: boolean) {
    var result = displayModalEditorComponent(component, size, options, this.modalService, formGroup);
    result.closed.subscribe((result: any) => {
      this.saveItem(result, isNew);
    });
  }

  abstract saveItem(item: T, isNew: boolean): void;

  abstract removeHandler({ dataItem }: any): void;

  public pageChange({ skip, take }: PageChangeEvent): void {
    this.skip = skip;
    this.pageSize = take;
    this.loadItems();
  }

  public loadItems(): void {
    this.gridData = {
      data: this.filteredItems.slice(this.skip, this.skip + this.pageSize),
      total: this.filteredItems.length,
    };
  }

  // For export all data to grid
  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: process(this.items, {}).data
    };

    return result;
  }

  // Use an arrow function to capture the 'this' execution context of the class.
  public rowCallback = (context: RowClassArgs) => {
    return 'customGridRow';
  };

  public pageSizeChange(value: any): void {
    this.skip = 0;
    this.loadItems();
  }

  public startnum() {
    return this.skip + 1;
  }

  public endnum() {
    return Math.min(this.skip + this.pageSize, this.gridData.total);
  }

  public checkBox(checked: boolean): string {
    if (checked) {
      return 'check-icon fa-light fa-square-check';
    }
    else {
      return 'check-icon fa-light fa-square-xmark';
    }
  }
}
